import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  width: 700px;
  height: 408px;
  left: 0px;
  top: 0px;
`;

export const ImagesHeader = styled.img`
  position: absolute;
  width: 700px;
  height: 408px;
  left: 0px;
  top: 0px;
`;

export const Rectangle = styled.div`
  position: absolute;
  width: 700px;
  height: 46px;
  left: 0px;
  top: 363px;
  background: #000000;
`;
